import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

import { ReportFormat } from '../SuitabilityFlow';

export type GenerateSuitabilityReportPayload = {
  reportTemplate?: string;
  supportingDataUploadFileIds?: string[];
  feeDocumentFileIds?: string[];
  appendixFileIds?: number[];
  temporaryAppendixFileIds?: number[];
  lastReviewDate?: string;
  reportFormat?: ReportFormat;
  addTitlePage?: boolean;
  addTableOfContents?: boolean;
  useDeepThinking?: boolean;
};

type MutationInput = {
  clientId: string;
  values: GenerateSuitabilityReportPayload;
};

export function useGenerateSuitabilityReport() {
  const queryClient = useQueryClient();

  const { mutateAsync, error, isLoading, reset } = useMutation<unknown, Error, MutationInput>({
    mutationFn: ({ clientId, values }: MutationInput) =>
      api.post(`clients/${clientId}/suitability-reports`, values),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const generateSuitabilityReport = async (
    clientId: string,
    values: GenerateSuitabilityReportPayload,
  ) => {
    return mutateAsync({ clientId, values });
  };

  return {
    generateSuitabilityReport,
    error,
    isLoading,
    reset,
  };
}
